import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/SignUp.css"
import google from "../images/google.png"
import { Checkbox, Form, Input,message } from 'antd';
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { KeyOutlined, UserOutlined } from "@ant-design/icons";
import { Button } from "@mui/material";


export default function SignUp () {
  const [loading,setLoading]=useState(false)
  let navigate=useNavigate()
  

  const [errorMessage,setErrorMessage]=message.useMessage();
  const [messageApi, contextHolder] = message.useMessage();
   //successfull message
   const success = () => {
    messageApi.open({
      type: 'success',
      content: 'successfuly  Registered',
      duration: 4,
    });
      setTimeout(()=>{
        navigate("/signIn")
      },2000)
  };
  
  //errror message
  const Error = (message) => {
   errorMessage.open({
     type: 'error',
     content: message,
     duration: 3,
   });
 
 };

 const onFinish = async(values) => {
  setLoading(true)

  let stringfy=JSON.stringify(values)
  axios.post(`${process.env.REACT_APP_URL}/api/user/register`,stringfy,{
    headers: {
      authorization:`xxxxxxxx`,
      'Content-Type': 'application/json'
    }
  })
   .then(function (response) {
    setLoading(false)
    console.log(response.data);
      success()
  }).catch((error) => {
    console.log(error);
    setLoading(false)
    if (error.response) {
      Error(error.response.data.error||"Error occured, please try again")
    } else if (error.request) {
      Error("Error occured, please try again")
    } else {
      Error("Error occured, please try again")
    }
    
  });
}

const onFinishFailed = (errorInfo) => {
  //console.log('Failed:', errorInfo);
};


    return (
        <>
          {setErrorMessage}
          {contextHolder}
        <div className="signup-container">
            <div className="signup-header">
              <div>Sign Up</div>
            </div>
            <div className="signup-form">
              <Form
                layout="vertical"
                name="basic"
                labelCol={{
                  span: 28,
                }}
                wrapperCol={{
                  span: 86,
                }}
                style={{
                  Width:800,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
          >
              <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: '',
                    }
                  ]}
                >
                <Input size="middle"  placeholder='username'  prefix={<UserOutlined />} />
              </Form.Item>

              <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: '',
                    },
                    {
                      type: 'email',
                      message: 'Invalid email',
                    },
                  ]}
                >
                <Input size="middle"  placeholder='email'  prefix={<UserOutlined />} />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
                hasFeedback
              >
                <Input.Password placeholder='password'  size="middle"  prefix={<KeyOutlined />}/>
               </Form.Item>

                <Form.Item
                    name="confirm"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Please confirm your password!',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject('The two passwords that you entered do not match!');
                        },
                      })
                    ]}
                  >
                  <Input.Password placeholder='Confirm Password' size="middle"  prefix={<KeyOutlined />}/>
                </Form.Item>

                <Form.Item
                 
                >
                  {loading?  <div className="signup-form-button"><CircularProgress size={24} color="success"/></div>: 
                <div className="signup-form-button"><button  htmlType="submit" >Sign up</button></div>
                }
                
                </Form.Item>
            </Form>
            
              <p className="signup-form-paragraph">Already have an account ? <Link to="/SignIn" className="signup-form-black">Sign in</Link></p>
              <div className="signin-footer">
                  <Button>
                      <div><img src={google} className="google-icon" /></div>
                      <div>Sign uo with Google</div>
                  </Button>
                </div>
            </div>
        </div>
        </>
      );
}


